import axios from 'axios'

const { PW_BASE_URL } = process.env

function created(userToken) {
  axios.defaults.headers.common.Authorization = `Bearer ${userToken}`
  axios.defaults.baseURL = PW_BASE_URL
}


const defaultAlternativePayments = [
  {
    name: '',
    clientId: '',
    environment: '',
    initiativeContext: '',
    merchantId: '',
    paymentDisplay: 'Apple Pay',
    processor: 'APPLE',
    wsgAccess: '',
    wsgUrl: '',
    wsgUser: '',
    addressSuppressed: false,
    newConfig: true
  },
  {
    name: '',
    clientId: '',
    keyID: '',
    merchantId: '',
    mwsAuthToken: '',
    paymentDisplay: 'Amazon Pay',
    processor: 'AMAZON',
    secretKey: '',
    wsgAccess: '',
    wsgUrl: '',
    wsgUser: '',
    addressSuppressed: false,
    newConfig: true,
    version: 1,
    authToken: '',
    onboardComplete: false
  },
  {
    name: '',
    cancelUrl: '',
    clientId: '',
    keyID: '',
    merchantId: '',
    paymentUrl: '',
    paymentDisplay: 'Pay Pal',
    processor: 'PAYPAL',
    ReturnUrl: '',
    SecretKey: '',
    WSGAccess: '',
    WSGUrl: '',
    WSGUser: '',
    addressSuppressed: false,
    newConfig: true,
    version: 1,
    onboardComplete: false
  }
]

/**
 * Include all supported credit card types.
 */
const cardTypes = ['visa', 'masterCard', 'discover', 'americanExpress']

/**
 * Include all supported alternative payment types.
 */
const altPayTypes = ['amazonPay', 'applePay', 'payPal']

function mapTypesArray(types = [], config = {}) {
  return types.map((key) => {
    return {
      key,
      pascal: key.replace(/([a-z]*)([A-Z]\w*)/g,
        (g0, g1, g2) => {
          return `${g1.toLowerCase()}-${g2.toLowerCase()}`
        }),
      contains: config[key]
    }
  }).filter(({ contains }) => contains)
    .map(({ pascal }) => pascal)
}

function convertExpiresAtToDate(data) {
  if (data.expiresAt) {
    data.expiresAt = new Date(data.expiresAt * 1000)
  }
  return data
}

export function dataAPI(userToken) {
  created(userToken)
  return {
    fetchConfiguration_DataAPI: (companyId) => {
      return axios.get(`/configurations/${companyId}`)
        .then(({ data }) => {
          const mapItem = (data) => {
            const selectedCardTypes = mapTypesArray(cardTypes, data)
            const selectedAltPaymentTypes = mapTypesArray(altPayTypes, data)
            const val = {
              ...data,
              cvv: data.cvv ? data.cvv : false,
              credit: selectedCardTypes.length > 0,
              selectedCardTypes,
              selectedAltPaymentTypes,
              altPaymentsAccepted: selectedAltPaymentTypes.length > 0,
              addressVerificationCodes: data.addressVerificationCodes ? data.addressVerificationCodes : [],
              recaptcha: data.recaptcha ? data.recaptcha : false,
              recaptchaSiteKey: data.recaptchaSiteKey ? data.recaptchaSiteKey : '',
              recaptchaDataCollection: data.recaptchaDataCollection ? data.recaptchaDataCollection : false
            }
            return val
          }
          return mapItem(data)
        })
    },
    saveConfiguration_DataAPI: (configId, configuration) => {
      const saveConfig = {
        ...configuration,
        cardPaymentsAccepted: (configuration.creditCardsAccepted) ? configuration.creditCardsAccepted : false,
        americanExpress: configuration.selectedCardTypes.includes('american-express'),
        masterCard: configuration.selectedCardTypes.includes('master-card'),
        visa: configuration.selectedCardTypes.includes('visa'),
        discover: configuration.selectedCardTypes.includes('discover'),
        alternativePayments: configuration.amazonPay || configuration.applePay || configuration.payPal,
        cdsGlobalWallet: (configuration.cdsGlobalWallet) ? configuration.cdsGlobalWallet : false,
        enableBillMeLater: (configuration.enableBillMeLater) ? configuration.enableBillMeLater : false,
        cvv: configuration.cvv,
        tokenizationStage: (configuration.selectedTokenizationStage) ? configuration.selectedTokenizationStage : 'AU',
        paymentService: (configuration.selectedPaymentService) ? configuration.selectedPaymentService : 'CPS',
        buttonsSize: (configuration && configuration.selectedButtonsSize) ? configuration.selectedButtonsSize : 'default',
        appSource: (configuration && configuration.selectedAppSource) ? configuration.selectedAppSource : '',
        recaptchaScoreThreshold: (configuration && configuration.selectedRecaptchaScoreThreshold) ? configuration.selectedRecaptchaScoreThreshold : ''
      }
      // only set transactionType if it is provided
      if (configuration.selectedTransactionType) {
        saveConfig.transactionType = configuration.selectedTransactionType
      }

      const newIdCheck = configId.match(/^new(:(.*))?$/)

      if (!newIdCheck) {
        return axios.put(`/configurations/${configId}`, saveConfig)
      }

      const customId = newIdCheck[2]

      if (customId) {
        return axios.post('/configurations', { ...saveConfig, customId })
      }
      return axios.post('/configurations', saveConfig)
    },
    duplicateConfiguration(configId, name) {
      return axios.post(`/configurations/${configId}/copy`, { name: `Copy of ${name}` })
    },
    deleteConfiguration(configId) {
      return axios.delete(`/configurations/${configId}`)
    },
    restoreConfiguration(configId) {
      return axios.get(`/configurations/${configId}/restore`)
    },
    fetchAllConfigsPerClient_DataAPI: (prodAliasId) => {
      return axios
        .get(`/configurations?clientId=${prodAliasId}`)
        .then(({ data }) => {
          return data.map(eachConfig => {
            const acceptedCards = mapTypesArray(cardTypes, eachConfig)
            const altPayments = mapTypesArray(altPayTypes, eachConfig)
            return convertExpiresAtToDate({
              clientId: eachConfig.clientId,
              'pw-config-id': eachConfig['pw-config-id'],
              config_name: {
                name: eachConfig.name,
                desc: eachConfig.description
              },
              name: eachConfig.name,
              configurationId: eachConfig.configurationId,
              cards: acceptedCards,
              alt_payments: altPayments,
              bill_me: (eachConfig.billMeLater) ? 'Yes' : 'No',
              wallet: (eachConfig.cdsGlobalWallet) ? 'Yes' : 'No',
              expiresAt: eachConfig.expiresAt
            })
          })
        })
    },
    fetchClients_DataAPI: () => {
      return axios.get('/clients')
        .then(({ data }) => {
          return data.map(d => convertExpiresAtToDate(d))
        })
    },
    createClient: (clientName, description) => {
      return axios.post('/clients', { name: clientName, description: description })
        .then(({ data }) => data)
    },
    deleteClient: (clientId) => {
      return axios.delete(`/clients/${clientId}`, {})
    },
    updateClient: (clientId, clientName, clientDescription) => {
      return axios.put(`/clients/${clientId}`, {
        name: clientName,
        description: clientDescription
      })
    },
    restoreClient: (clientId) => {
      return axios.get(`/clients/${clientId}/restore`)
    },
    getPaymentsByClientId: (clientId, processor) => {
      let path = `/payments?clientId=${clientId}`
      if (processor) {
        path += `&processor=${processor}`
      }
      return axios.get(path)
        .then(({ data }) => data.map(v => convertExpiresAtToDate(v)))
    },
    getPaymentById(paymentType, paymentId, clientId, configurationId) {
      let url
      if (clientId && paymentId) {
        url = `/payments/${paymentType}/${paymentId}?clientId=${clientId}`
      } else if (configurationId) {
        url = `/payments/${paymentType}?configurationId=${configurationId}`
      }
      if (paymentId !== 'new') {
        return axios.get(url)
          .then(data => data.data)
      } else {
        return new Promise(resolve => resolve(defaultAlternativePayments
          .map((k) => { return { ...k, clientId: clientId } })
          .find((i) => i.processor === paymentType)))
      }
    },
    getPaymentByType (coId, type) {
      return axios.get(`/payments?clientId=${coId}&processor=${type}`)
        .then(({ data }) => {
          const item = data.length > 0 ? data[0] : {}
          const { CoID } = item
          const displayNames = [
            { processor: 'APPLE', PaymentDisplay: 'Apple Pay' },
            { processor: 'AMAZON', PaymentDisplay: 'Amazon Pay' },
            { processor: 'PAYPAL', PaymentDisplay: 'Pay Pal' }
          ]

          const display = displayNames.find((k) => {
            return item.processor === k.processor
          })
          const built = { ...item, ...display }
          return CoID === coId ? built : defaultAlternativePayments
            .map((k) => { return { ...k, clientId: coId } })
            .find(({ processor }) => processor === type)
        })
    },
    createAlternativePayment (payment) {
      return axios.post('/payments', payment)
        .then(data => data.data)
    },
    updateAlternativePayment(payment) {
      let url
      if (payment.clientId) {
        url = `/payments/${payment.processor}/${payment.paymentId}?clientId=${payment.clientId}`
      } else {
        url = `/payments/${payment.processor}?configurationId=${payment.configurationId}`
      }
      return axios.put(url, payment)
    },
    copyAlternativePaymentFromPublisher(payment) {
      const url = `/payments/${payment.processor}/${payment.paymentId}/copy`
      return axios.post(url, {
        clientId: payment.clientId,
        configurationId: payment.configurationId
      }).then(({ data }) => data)
    },
    deletePayment: (payment, clientId, configurationId) => {
      let path = `/payments/${payment.processor}/${payment.paymentId}`
      if (clientId) {
        path = path + `?clientId=${clientId}`
      } else if (configurationId) {
        path = path + `?configurationId=${configurationId}`
      } else {
        throw new Error('clientId or configurationId is required')
      }
      return axios.delete(path)
    },
    restorePayment: (payment, clientId, configurationId) => {
      let path = `/payments/${payment.processor}/${payment.paymentId}/restore`
      if (clientId) {
        path = path + `?clientId=${clientId}`
      } else if (configurationId) {
        path = path + `?configurationId=${configurationId}`
      } else {
        throw new Error('clientId or configurationId is required')
      }
      return axios.get(path)
    },
    publishAllConfigurations() {
      return axios.post('/configurations/publishAll')
    },
    getProperties() {
      return axios.get('/properties').then(({ data }) => {
        return data
      })
    },
    updateProperty(property) {
      return axios.put('/properties/' + property.key, property)
    },
    deleteProperty(propertyKey) {
      return axios.delete('/properties/' + propertyKey)
    },
    getBlacklists() {
      return axios.get('/blacklists').then(({ data }) => {
        return data.map(v => convertExpiresAtToDate(v))
      })
    },
    getSearchConfigurations(searchValue) {
      const path = `/search/?searchValue=${searchValue}`
      return axios.get(path).then(({ data }) => {
        return data
      })
    },
    deleteBlacklist(ipAddress) {
      return axios.delete('/blacklists/' + ipAddress)
    }
  }
}
